import type { DemoKey } from '../types';

export const pl: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Matematyka · Statystyka',
  'app.title': 'Statystyka',
  'panel.experiment': 'Scena',
  'panel.params': 'Parametry',

  'exp.survey-explorer.title': 'Eksplorator ankiety',
  'exp.survey-explorer.desc': 'Wybierz kolumnę; demo dobierze odpowiednie podsumowanie.',
  'exp.distribution-sculptor.title': 'Rzeźbiarz rozkładów',
  'exp.distribution-sculptor.desc': 'Przeciągaj punkty i patrz, jak reagują statystyki.',
  'exp.two-variable-lab.title': 'Laboratorium dwóch zmiennych',
  'exp.two-variable-lab.desc': 'Rozrzut, dopasowanie i pytanie o przyczynowość.',
  'exp.sampling-lab.title': 'Laboratorium próbkowania',
  'exp.sampling-lab.desc': 'Jak technika i wielkość przesuwają średnią próby.',
  'exp.probability-diagrams.title': 'Diagramy prawdopodobieństwa',
  'exp.probability-diagrams.desc': 'Widoki Venna i drzewa dla zdarzeń złożonych.',

  'type.qualitative-nominal.label': 'Jakościowa · nominalna',
  'type.qualitative-nominal.def': 'Kategorie bez naturalnej kolejności.',
  'type.qualitative-ordinal.label': 'Jakościowa · porządkowa',
  'type.qualitative-ordinal.def': 'Kategorie z istotną kolejnością.',
  'type.qualitative-multi.label': 'Jakościowa · wielowartościowa',
  'type.qualitative-multi.def': 'Każda obserwacja może mieć wiele etykiet.',
  'type.quantitative-discrete.label': 'Ilościowa · dyskretna',
  'type.quantitative-discrete.def': 'Liczby w stałych krokach.',
  'type.quantitative-continuous.label': 'Ilościowa · ciągła',
  'type.quantitative-continuous.def': 'Liczby mierzone na ciągłej skali.',

  'column.name.label': 'Imię ucznia',
  'column.height_cm.label': 'Wzrost',
  'column.shoe_size_eu.label': 'Rozmiar buta (EU)',
  'column.study_hours.label': 'Godziny nauki / tydz.',
  'column.test_score.label': 'Wynik testu',
  'column.sports_played.label': 'Uprawiane sporty',
  'column.eye_color.label': 'Kolor oczu',
  'column.commute_min.label': 'Dojazd',
  'column.grade_year.label': 'Klasa',
  'column.homework_effort.label': 'Wysiłek przy pracy domowej',
  'column.ice-cream-sales.label': 'Sprzedaż lodów',
  'column.drownings.label': 'Utonięcia',
  'column.month.label': 'Miesiąc',
  'column.storks.label': 'Bociany',
  'column.births.label': 'Narodziny',
  'column.country_area_km2.label': 'Powierzchnia kraju',
  'column.sleep_hours.label': 'Godziny snu',
  'column.reaction_ms.label': 'Czas reakcji',

  'dataset.master-survey.label': 'Ankieta klasowa',
  'dataset.master-survey.desc': '30 symulowanych uczniów.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Sprzedaż lodów vs utonięcia',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Oba rosną i spadają wraz z sezonem. Utonięcia nie powodują sprzedaży lodów.',
  'dataset.spurious-storks-vs-births.label': 'Bociany vs narodziny',
  'dataset.spurious-storks-vs-births.desc':
    'Większe kraje mają więcej bocianów i więcej narodzin. Ptaki nie są przyczyną.',
  'dataset.real-sleep-vs-reaction-time.label': 'Sen vs czas reakcji',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Więcej snu, szybsze reakcje. Realna ujemna korelacja — z wiarygodnym mechanizmem.',

  'tag.football.label': 'Piłka nożna',
  'tag.basketball.label': 'Koszykówka',
  'tag.volleyball.label': 'Siatkówka',
  'tag.swimming.label': 'Pływanie',
  'tag.none.label': 'Żaden',

  'population.gaussian.label': 'Krzywa dzwonowa',
  'population.right-skewed.label': 'Skośna w prawo',
  'population.bimodal.label': 'Dwumodalny (warstwy)',
  'population.uniform.label': 'Jednostajny',

  'venn.dice-even-or-prime.label': 'Kostka: parz. lub pierwsza',
  'venn.class-sports-2set.label': 'Sporty (2 zbiory)',
  'venn.class-sports-3set.label': 'Sporty (3 zbiory)',
  'venn.custom.label': 'Własne',

  'tree.draw-without-replacement.label': 'Losowanie bez zwracania',
  'tree.custom.label': 'Własne',
  'tree.coin.heads': 'O',
  'tree.coin.tails': 'R',
  'tree.draw.start': 'Worek: 2 czerwone, 3 niebieskie',
  'tree.draw.red': 'Czerwony',
  'tree.draw.blue': 'Niebieski',
  'tree.custom.start': 'Start',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Histogram',
  'card.cumulative': 'Częstość skumulowana',
  'card.box': 'Wykres pudełkowy',
  'card.summary': 'Podsumowanie 5-liczbowe',
  'card.bar': 'Wykres słupkowy',
  'card.mode': 'Dominanta',
  'card.tag-frequency': 'Częstość etykiet',
  'card.mode-tag': 'Dominująca etykieta',
  'card.empty-no-order': 'Nie dotyczy',
  'card.empty-multi': 'Nie dotyczy',
  'card.numberline': 'Oś liczbowa',
  'card.scatter': 'Rozrzut',
  'card.description': 'Co się dzieje',
  'card.population': 'Populacja',
  'card.sampling-distribution': 'Średnie próbek',
  'card.venn': 'Venn',
  'card.tree': 'Drzewo',
  'card.probabilities': 'Prawdopodobieństwa',

  'param.dataset.label': 'Zbiór danych',
  'param.column.label': 'Kolumna',
  'param.bins.label': 'Przedziały',
  'param.shape.label': 'Kształt początkowy',
  'param.show-mean.label': 'Pokaż średnią',
  'param.show-median.label': 'Pokaż medianę',
  'param.x-col.label': 'Kolumna X',
  'param.y-col.label': 'Kolumna Y',
  'param.show-regression.label': 'Linia regresji',
  'param.show-residuals.label': 'Reszty',
  'param.show-confounder.label': 'Pokaż czynnik zakłócający',
  'param.population.label': 'Populacja',
  'param.technique.label': 'Technika',
  'param.sample-size.label': 'Wielkość próby',
  'param.stratum.label': 'Warstwa',
  'param.bias.label': 'Obciążenie',
  'param.mode.label': 'Tryb',
  'param.preset.label': 'Predefiniowane',
  'param.universe.label': 'Wielkość uniwersum',
  'param.show-prob.label': 'Pokaż prawdopodobieństwa',
  'param.treat-as-numeric.label': 'Traktuj jak liczbę',

  'stat.count': 'Liczba',
  'stat.mean': 'Średnia',
  'stat.median': 'Mediana',
  'stat.range': 'Zakres',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'Wartości odstające',
  'stat.r': 'r Pearsona',
  'stat.r2': 'r²',
  'stat.slope': 'Nachylenie',
  'stat.intercept': 'Wyraz wolny',
  'stat.n': 'n',
  'stat.population-mean': 'Średnia rzeczywista',
  'stat.latest-sample-mean': 'Średnia próby',
  'stat.sample-mean-spread': 'SD średniej próby',
  'stat.sample-count': 'Pobrane próby',
  'outlier.upper': 'Odstające górne',
  'outlier.lower': 'Odstające dolne',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Pobierz na nowo',
  'btn.run-100': 'Pobierz 100 prób',
  'btn.stop': 'Stop',
  'btn.clear-history': 'Wyczyść historię',

  'explainer.no-order': 'Brak kolejności → brak skumulowanej, brak pudełka.',
  'explainer.multi-no-iqr': 'Wielowartościowe → kwartyle / IQR niezdefiniowane.',
  'message.no-data': 'Brak danych.',
  'message.needs-quartiles': 'Do kwartyli potrzeba ≥4 punktów.',
  'message.x-zero-variance': 'X ma wariancję zero — brak prostej do dopasowania.',
  'message.n-too-small': 'n zbyt małe.',
  'message.stratum-clamp': 'Warstwa miała mniej wierszy niż żądano — użyto wszystkich.',
  'message.siblings-sum-to-one': 'Suma dzieci musi wynosić 1.',
};
